import { render, staticRenderFns } from "./PaytableTitle.vue?vue&type=template&id=52067fa1&"
import script from "./PaytableTitle.vue?vue&type=script&lang=ts&"
export * from "./PaytableTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableTitle.vue?vue&type=style&index=0&id=52067fa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports